const keyMap = {
  '1:MULTI:1': {
    mainKey: '1D',
    supKey: 'top_run_three',
    groupKey: ''
  },
  '1:MULTI:2': {
    mainKey: '1D',
    supKey: 'main_select_group',
    groupKey: ''
  },
  '2:MULTI:ORDER:1': {
    mainKey: '2D',
    supKey: 'top_on_two',
    groupKey: ''
  },
  '2:MULTI:ORDER:2': {
    mainKey: '2D',
    supKey: 'bottom_on_two',
    groupKey: ''
  },
  '3:MULTI:1': {
    mainKey: '3D',
    supKey: 'top_off_three',
    groupKey: ''
  },
  '3:MULTI:ORDER:1': {
    mainKey: '3D',
    supKey: 'top_on_three',
    groupKey: ''
  },
  '3:MULTI:ORDER:2': {
    mainKey: '3D',
    supKey: 'before_three',
    groupKey: ''
  },
  '3:MULTI:ORDER:3': {
    mainKey: '3D',
    supKey: 'after_three',
    groupKey: ''
  }
}

export default keyMap
